import {h, Fragment} from "preact"
export default function FacetColorElement({ value, selected, onChange, className }) {
    const colorName = value?.toLowerCase() || 'black';

    return (
        <div class="ss__palette__option--container">
            <div class={`ss__palette__option ${selected ? 'ss__active' : ''}`}>
                <div class="ss__palette__link" onClick={onChange} style="cursor: pointer;">
                    <div class={`ss__palette__block ss__palette__block--${colorName} `}>
                        {/* <div class="ss__palette__border" style={`border-color: ${colorName};`}></div>
                        <div class="ss__palette__color" style={`background-color: ${colorName};`}></div> */}
                        {/* <div class="ss__palette__border" style={`border-color: ${window.nostoCustomColors[colorName] ? window.nostoCustomColors[colorName] : colorName};`}></div>
                        <div class="ss__palette__color" style={`background-color: ${window.nostoCustomColors[colorName] ? window.nostoCustomColors[colorName] : colorName};`}></div> */}
                        <div class="ss__palette__border" style={`border-color: ${window.nostoCustomColors?.[colorName] || colorName};`}></div>
                        <div class="ss__palette__color" style={`background-color: ${window.nostoCustomColors?.[colorName] || colorName};`}></div>
                    </div>
                </div>
                <div class="ss__palette__label">{value}</div>
            </div>
        </div>
    )
}